var _a;
import { localStorageSync } from 'ngrx-store-localstorage';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { createEventsMetaReducer } from '@awp/google-tag';
import { environment } from '../../environments/environment';
import { ActionTypes } from './actions';
export var reducers = {};
export function localStorageSyncReducer(reducer) {
    return localStorageSync({
        keys: ['cardCheck', 'quote', 'data'],
        rehydrate: true,
        storage: sessionStorage,
    })(reducer);
}
export function clearState(reducer) {
    return function (state, action) {
        if (action.type === ActionTypes.RESET_STATE) {
            state = {};
        }
        return reducer(state, action);
    };
}
var eventsMap = (_a = {},
    _a[ROUTER_NAVIGATED] = function (action) {
        // Router Navigated Action
        return {
            hitType: 'pageview',
            page: action.payload.event.url
        };
    },
    _a[ActionTypes.APP_THEME_CHANGED] = function (action) {
        return {
            hitType: 'event',
            themeId: action.payload
        };
    },
    _a);
var gtmMetaReducer = createEventsMetaReducer(eventsMap);
export function gtmReducer(reducer) {
    return gtmMetaReducer(reducer);
}
// Todo: Do not include GTM in development mode
export var metaReducers = !environment.production
    ? [localStorageSyncReducer, clearState, gtmReducer]
    : [localStorageSyncReducer, clearState, gtmReducer];
